import {
HttpHandler,
HttpInterceptor,
HttpRequest
} from '@angular/common/http';
import { Inject,Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { ProgressService,ProgressServiceToken } from '../services';

@Injectable()
export class ProgressInterceptor implements HttpInterceptor {
  constructor(@Inject(ProgressServiceToken) private service: ProgressService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.method === 'GET' || req.url.indexOf('document') !== -1) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      tap({ next: event => this.service.progressEventObservable.next(event), error: event => this.service.progressEventObservable.error(event) })
      // finalize when observable
      // finalize(() => { })
    );
  }

  /*build(): any {
    let xhr = super.build();
    xhr.upload.onprogress = (event) => {
        this.service.progressEventObservable.next(event);
    };
    xhr.upload.onerror = (event) => {
        this.service.progressEventObservable.error(event);
    };
    return <any>(xhr);
  } */
}
